/**
 * Feature-local route-name constants for the GvG planner surface.
 *
 * Phase 7 split the original `@/constants/routes` ROUTE_NAMES into two
 * scopes: the planner owns everything this feature serves (`/:guildId/plan/:raidId`,
 * `/officers`, `/onboarding`, `/my-builds`), and the host
 * shell owns the calendar + 404 (`@/shared/constants/routes`).
 *
 * The string VALUES stay byte-identical to Phase 6 (`'gvg-planner'`,
 * `'officers'`, etc.) so:
 *
 *   - hard-coded `router.push({ name: 'gvg-planner' })` call-sites keep
 *     resolving;
 *   - the regression tests that snapshot `route.name` literals still pass;
 *   - deep links / browser history from before the refactor still load the
 *     same view.
 *
 * Update the 114-key public API snapshot test
 * (`features/gvg-planner/stores/__tests__/publicApi.snapshot.test.ts`) only
 * when you intentionally rename a route — and only by changing this file.
 */
export const FEATURE_ROUTE_NAMES = {
  GvgPlanner: 'gvg-planner',
  Officers: 'officers',
  AuditLog: 'audit-log',
  Onboarding: 'onboarding',
  MyBuilds: 'my-builds',
} as const

export type FeatureRouteName =
  (typeof FEATURE_ROUTE_NAMES)[keyof typeof FEATURE_ROUTE_NAMES]
